import XContentCard from './XContentCard'
import XContentCardHeader from './XContentCardHeader'

export default XContentCard
export { XContentCard, XContentCardHeader }
